import React from 'react'
import { Row, Col, Select } from 'antd'
import ColorBox from './ColorBox'
import data from './data.js'
import Color from './Color'

export default class Board extends React.Component {
  state={}
  componentDidMount() {
    const {slug} = this.props
    const {colors} = data
    const {name,list} = colors.find(e=>e.slug===slug)
    this.setState({name,list})
  }
  static getDerivedStateFromProps(props,state) {
    const {slug} = props
    const {colors} = data
    const {name,list} = colors.find(e=>e.slug===slug)
    return {name,list}
  }
  onCopy=color=>{
    if (color instanceof Color) {
      this.setState({copied:color})
    }
  }
  renderList() {
    const {list,copied} = this.state
    if (Array.isArray(list)&&list.length>0) {
      const {format} = this.props
      return (
        <Row>
          {
            list.map((e,i)=>(
              <Col key={i} xs={12} sm={8} md={8} lg={6} xl={4}>
                <ColorBox
                  value={e}
                  format={format}
                  copied={copied}
                  onCopy={this.onCopy}
                />
              </Col>
            ))
          }
        </Row>
      )
    }
    return null
  }
  onSelect=value=>{
    const {onChange} = this.props
    if (typeof(onChange)==='function') {
      onChange(value)
    }
  }
  renderFormatPicker() {
    const {format} = this.props
    if (typeof(format)==='string'&&format.length>0) {
      return (
        <Select defaultValue={format} style={{width:120}} onChange={this.onSelect} value={format}>
          {
            Color.formats.map((e,i)=>(
              <Select.Option key={i} value={e}>{e.toUpperCase()}</Select.Option>
            ))
          }
        </Select>
      )
    }
    return null
  }
  render() {
    const {name} = this.state
    const {className} = this.props
    return (
      <div className={className}>
        <div className="mb-3">
          <div>
            <div className="float-left filler" />
            <div className="float-right mb-3">
              {this.renderFormatPicker()}
            </div>
          </div>
          <h1 className="text-center">{name}</h1>
          <div className="mb-3">
            <p className="text-center">Click the color to copy</p>
          </div>
        </div>
        {this.renderList()}
      </div>
    )
  }
}
